import { getRealmUrlPath } from './realm.js';

/*
 * @forgerock/javascript-sdk
 *
 * url.ts
 *
 * Copyright (c) 2020 ForgeRock. All rights reserved.
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file for details.
 */
/**
 * Returns the base URL including protocol, hostname and any non-standard port.
 * The returned URL does not include a trailing slash.
 */
function getBaseUrl(url) {
    const isNonStandardPort = (url.protocol === 'http:' && ['', '80'].indexOf(url.port) === -1) ||
        (url.protocol === 'https:' && ['', '443'].indexOf(url.port) === -1);
    const port = isNonStandardPort ? `:${url.port}` : '';
    const baseUrl = `${url.protocol}//${url.hostname}${port}`;
    return baseUrl;
}
function getEndpointPath(endpoint, realmPath, customPaths) {
    const realmUrlPath = getRealmUrlPath(realmPath);
    const defaultPaths = {
        authenticate: `json/${realmUrlPath}/authenticate`,
        authorize: `oauth2/${realmUrlPath}/authorize`,
        accessToken: `oauth2/${realmUrlPath}/access_token`,
        endSession: `oauth2/${realmUrlPath}/connect/endSession`,
        userInfo: `oauth2/${realmUrlPath}/userinfo`,
        revoke: `oauth2/${realmUrlPath}/token/revoke`,
        sessions: `json/${realmUrlPath}/sessions/`,
    };
    if (customPaths && customPaths[endpoint]) {
        // TypeScript is not correctly reading the condition above
        // It's thinking that customPaths[endpoint] may result in undefined
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return customPaths[endpoint];
    }
    else {
        return defaultPaths[endpoint];
    }
}
function resolve(baseUrl, path) {
    const url = new URL(baseUrl);
    if (path.startsWith('/')) {
        return `${getBaseUrl(url)}${path}`;
    }
    const basePath = url.pathname.split('/');
    const destPath = path.split('/').filter((x) => !!x);
    const newPath = [...basePath.slice(0, -1), ...destPath].join('/');
    return `${getBaseUrl(url)}${newPath}`;
}
function parseQuery(fullUrl) {
    const url = new URL(fullUrl);
    const query = {};
    url.searchParams.forEach((v, k) => (query[k] = v));
    return query;
}
function stringify(data) {
    const pairs = [];
    for (const k in data) {
        if (data[k]) {
            pairs.push(k + '=' + encodeURIComponent(data[k]));
        }
    }
    return pairs.join('&');
}

export { getBaseUrl, getEndpointPath, parseQuery, resolve, stringify };
